import { jsx } from "react/jsx-runtime";
const PartialPageFallback = () => {
  return /* @__PURE__ */jsx("div", {
    style: {
      backgroundColor: "white",
      color: "black",
      position: "relative",
      zIndex: 100
    },
    children: /* @__PURE__ */jsx("p", {
      children: "Something went wrong. Try refreshing the page."
    })
  });
};
export default PartialPageFallback;